import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";

import { Assistant } from "../../api";

interface Props {
    onAssistantSelected: () => void;
    windowWidth: number;
    onNewAssistant: () => void;
}

export const AssistantSelector = ({ onAssistantSelected, windowWidth, onNewAssistant }: Props) => {
    const appStateContext = useContext(AppStateContext);

    const onAssistantClicked = (assist: Assistant) => {
        appStateContext?.dispatch({ type: "UPDATE_ASSISTANT", payload: assist });
        onAssistantSelected();
        onNewAssistant();
    };

    return (
        <div className="flyout-container relative">
            {appStateContext?.state.assistants && appStateContext?.state.assistants?.length > 1 && (
                <div className="flyout-button flex justify-start cursor-pointer h-14 w-auto whitespace-nowrap items-center transition-all ease-linear duration-300">
                    <a className="text-sm leading-6 font-normal tracking-wider">
                        {windowWidth >= 976 ? appStateContext?.state.assistant?.title : appStateContext?.state.assistant?.name}
                    </a>
                    <div className="px-2">
                        <svg
                            stroke="currentColor"
                            fill="none"
                            stroke-width="0"
                            viewBox="0 0 24 24"
                            className="flyout-chevron-down stroke-sstl-yellow transition-all ease-in-out duration-300 rotate-0"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </div>
                </div>
            )}
            {appStateContext?.state.assistants && appStateContext?.state.assistants?.length === 1 && (
                <div className="flex self-center whitespace-nowrap px-4 py-0">
                    <div className="text-sm	leading-6 font-bold">
                        {windowWidth >= 976 ? appStateContext?.state.assistant?.title : appStateContext?.state.assistant?.name}
                    </div>
                </div>
            )}
            {appStateContext?.state.assistants && appStateContext?.state.assistants?.length > 1 && (
                <div className="flyout-menu hidden absolute top-full right-1/2 translate-x-1/2 z-10 md:w-80 w-screen transition-all ease-linear duration-300 bg-sstl-white shadow-lg">
                    <div className="py-2 px-5">
                        <div className="flex flex-col">
                            {appStateContext?.state.assistants &&
                                appStateContext?.state.assistants.map((assist, index) => (
                                    <div className="leading-7 font-normal py-2">
                                        <a
                                            className="gap-1 w-fit ease-linear transition-transform duration-300 flex cursor-pointer text-center items-center text-lg hover:text-sstl-blue whitespace-nowrap"
                                            onClick={() => onAssistantClicked(assist)}
                                        >
                                            <span className="text-[0.875rem]">
                                                <span className="hover-underline pb-[3px]">{assist.title}</span>
                                            </span>
                                        </a>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
